import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure1 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#ff0000', '#ffd2d2'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
		   'Malawi 2015',
		   'Nigéria 2013',
		   'Nigéria 2018',
		   'Burundi 2016',
		   'Ouganda 2014',
		   'Togo 2018',
		   'Pakistan 2018',
		   'Cameroun 2018',
		   'Zambie 2018',
		   'Niger 2018',
		   'Afrique du Sud 2016',
		   'Guinée 2018',
		   'Bénin 2018',
		   'Côte d’Ivoire 2018',
		   'Zimbabwe 2015',
		   'Guinée-Bissau 2018',
		   'Burkina Faso 2018',
		   'République-Unie de Tanzanie 2013',
		   'Mali 2018',
		   'Éthiopie 2016',
		   'Albanie 2018',
		   'Sénégal 2018',
		   'Arménie 2016',
		   'Indonésie 2017',
		   'Mozambique 2011',
		   'Lesotho 2013',
		   'Mongolie 2012',
		   'Rwanda 2015',
		   'Belgique 2011',
		   'Nouvelle-Zélande 2013',
		   'Suède 2011',
		   'République de Corée 2016',
		   'Royaume des Pays-Bas 2011',
		   'Costa Rica 2011',
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 100,
      min: 0,
      tickInterval: 10,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: 'Femmes',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	     22.6,
	     16.2,
	     3.4,
	     3.6,
	     52.5,
	     29.2,
	     1.5,
	     2.7,
	     3.9,
	     1.8,
	     10.6,
	     6.6,
	     10,
	     9,
	     8.2,
	     21.2,
	     13.2,
	     33.9,
	     11.4,
	     18,
	     21.9,
	     22.4,
	     29.7,
	     12,
	     11.2,
	     null,
	     26.8,
	     86.4,
	     54.3,
	     null,
	     30.2,
	     null,
	     64,
	     null,
      ]
    },{
        name: 'Population totale',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [

	     1.9,
	     2.1,
	     7.7,
	     7.8,
	     8,
	     9.2,
	     9.8,
	     9.8,
	     10.3,
	     12.8,
	     15.8,
	     16.5,
	     17.1,
	     17.9,
	     21.4,
	     21.7,
	     24.6,
	     25,
	     26.9,
	     32.2,
	     36.4,
	     39.9,
	     41.9,
	     45.8,
	     49.8,
	     61.1,
	     65.4,
	     85.8,
	     94.8,
	     99,
	     99.3,
	     100,
	     100,
	     100,
	     
      ],
    }]
}
